import { render } from "./RelatedRoadMap.vue?vue&type=template&id=46020924"
import script from "./RelatedRoadMap.vue?vue&type=script&lang=ts"
export * from "./RelatedRoadMap.vue?vue&type=script&lang=ts"
script.render = render

export default script